import React, {useState, useEffect} from 'react';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';
import './style.scss';

export default function LabelWithInfo({
  text = '',
  labelclassname = '',
  children,
  inline = false,
  ...props
}) {
  const {customDialog} = useCustomDialog();

  const onClickInfo = async () => {
    await customDialog({
      buttons: ButtonLayout.None,
      description_element: children,
    });
  };

  return (
      <div className={`LabelWithInfo ${inline ? 'inline' : ''}`} {...props}>
        <h4>
          <span className={labelclassname}>{text}</span>

          <div
              className="info-icon"
              onClick={() => {
                onClickInfo();
              }}
          ></div>
        </h4>
      </div>
  );
}
